import { useTranslation } from "react-i18next";
import { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

import BaseButton from "@/components_v2/Button/BaseButton";
import DataFilesTable from "@/features/files/list/components/DataFilesTable";
import CreateDataFileModal from "@/features/files/list/components/CreateDataFileModal";
import { selectCurrentUser } from "@/redux/authentication/selectors";
import { BUTTON_SIZES } from "@/components_v2/Button/constants";

import "./styles.css";

const DataFileList = () => {
  const { t } = useTranslation();

  const currentUser = useSelector(selectCurrentUser);
  const [openUploadModal, setOpenUploadModal] = useState(false);

  return (
    <div className="page-layout">
      <div className="page-header">
        <h1 className="header-l-medium">
          {t("datablocks.labels.fileRepository")}
        </h1>

        <BaseButton
          size={BUTTON_SIZES.SMALL}
          leadingIcon={<PlusOutlined />}
          onClick={() => {
            setOpenUploadModal(true);
          }}
        >
          {t("datablocks.labels.uploadFiles")}
        </BaseButton>
      </div>

      {currentUser && (
        <DataFilesTable
          columnNames={[
            "name",
            "extension",
            "references",
            "uploadedAt",
            "uploadedBy",
            "actions",
          ]}
          filterNames={["search", "extensions", "uploadedAt", "uploadedBy"]}
          defaultFilters={{
            editable: true,
            organization: currentUser.organization?.id,
          }}
        />
      )}

      <CreateDataFileModal
        open={openUploadModal}
        setOpen={setOpenUploadModal}
      />
    </div>
  );
};

export default DataFileList;
